
































import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable/useDeclination';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { ProductBannerModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'ProductBannerDesktopDeclanation1',
  components: {
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  props: {
    declinationData: {
      required: true,
      type: Object as PropType<ProductBannerModel & MediaPreloadableSection>
    }
  },
  setup(props) {
    const { getBannerData, getCTAdata } = useDeclination(props.declinationData);

    return {
      getBannerData,
      getCTAdata
    };
  }
});
